import { render, staticRenderFns } from "./VeJwTjSettingList.vue?vue&type=template&id=15fd62f0&scoped=true"
import script from "./VeJwTjSettingList.vue?vue&type=script&lang=js"
export * from "./VeJwTjSettingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fd62f0",
  null
  
)

export default component.exports